import { ReactElement } from 'react';
import { Message } from '@messageformat/react';
import { space } from '@op/opds.tokens';
import { IconFunds, IconEtf, IconStock } from '@op/opds.opux-icons/finance';
import TextComponent from '../TextComponent';
import styles from './PartFour.module.scss'; // Import the CSS module
import InfoTile from './InfoTile';

const PartFour = (): ReactElement => {
  return (
    <>
      <div
        className="investoracademy-number"
        style={{ marginTop: space.large, marginBottom: space.default }}
      >
        4
      </div>
      <h2
        className="opds-styles-v1-text-hero-small"
        style={{
          textAlign: 'center',
          paddingBottom: space.xl,
        }}
      >
        <Message id="course8.part4.title" />
      </h2>
      <p className="investoracademy-text-paragraph" style={{ marginBottom: space.large }}>
        <Message id="course8.part4.infotext1" />
      </p>
      <div className={styles['icon-container']}>
        <div className={styles['icon-circle']}>
          <IconFunds size="large" />
        </div>
        <div className={styles['icon-circle']} style={{ marginLeft: '-1em' }}>
          <IconEtf size="large" />
        </div>
      </div>
      <h3 className="opds-styles-v1-text-title-xxl investoracademy-centered-and-padding-default-text">
        <Message id="course8.part4.subtitle1" />
      </h3>

      <TextComponent messageId="course8.part4.body1" twoColumns />
      <div style={{ marginBottom: space.xxxl }}>
        <h3 className="opds-styles-v1-text-title-large investoracademy-centered-and-padding-default-text">
          <Message id="course8.part4.responsibilityarticletitle" />
        </h3>
        <p
          className="investoracademy-text-paragraph"
          style={{ marginBottom: space.large }}
        >
          <Message id="course8.part4.responsibilityarticleintro" />
        </p>
        <InfoTile
          number="6"
          description="course8.part4.responsibilitytiles.0.description1"
        />
        <InfoTile
          number="8"
          description={[
            'course8.part4.responsibilitytiles.1.description1',
            'course8.part4.responsibilitytiles.1.description2',
          ]}
        />
        <InfoTile
          number="9"
          description={[
            'course8.part4.responsibilitytiles.2.description1',
            'course8.part4.responsibilitytiles.2.description2',
            'course8.part4.responsibilitytiles.2.description3',
          ]}
        />
      </div>
      <div className={styles['icon-container']}>
        <div className={styles['icon-circle']}>
          <IconStock size="large" />
        </div>
      </div>
      <h3 className="opds-styles-v1-text-title-xxl investoracademy-centered-and-padding-default-text">
        <Message id="course8.part4.subtitle2" />
      </h3>
      <TextComponent messageId="course8.part4.body2" twoColumns />
    </>
  );
};

export default PartFour;
